import React from "react";
import images from "../../assets";
import ActivityTimelineValue from "./activitytimelinevalue";
import { Select } from "antd";
import ActivityTimelineCard from "./activitytimelinecard";

export default function ActivityTimelineComp() {
  return (
    <div className="w-full flex flex-col gap-6">
      <h2>Activity Timeline</h2>
      <div className="w-full justify-start items-start gap-[19px] flex flex-wrap">
        <div className="w-[586px] p-5 bg-white rounded-xl shadow border border-primary50 flex-col justify-start items-start gap-2.5 inline-flex">
          <div className="self-stretch flex-col justify-center items-end gap-2.5 flex">
            <div className="self-stretch flex-col justify-start items-start gap-[39px] flex">
              <div className="self-stretch flex-col justify-start items-center gap-6 flex">
                <h3 className="text-[#222222] text-base font-semibold font-['Poppins'] leading-normal">
                  Total Activities
                </h3>
                <p className="text-secondary text-7xl font-semibold leading-[72px]">
                  1120
                </p>
              </div>
              <div className="self-stretch flex-col justify-start items-start gap-2 flex">
                <ActivityTimelineValue
                  title="Average Activity"
                  value="25/visit"
                />
                <ActivityTimelineValue
                  title="Last Spent Time"
                  value="17 mins"
                />
                <ActivityTimelineValue
                  title="Last Activity Type"
                  value="Photo Request"
                />
                <ActivityTimelineValue
                  title="Total Number of Visits"
                  value="27"
                />
              </div>
            </div>
            <div className="justify-start items-center gap-2 inline-flex">
              <div className="text-right text-[#222222]/60 text-xs font-normal font-['Poppins'] leading-[18px]">
                Updated today at 11:46 am
              </div>
              <div className="w-5 h-5 relative">
                <img src={images.syneIcon} />
              </div>
            </div>
          </div>
        </div>

        <div className="w-[290px] px-4 py-5 bg-white rounded-2xl shadow border border-primary50 flex-col justify-between items-start gap-6 flex">
          <div className="justify-center items-center gap-3 inline-flex">
            <div className="text-center text-[#222222] text-sm font-normal font-['Poppins'] leading-tight">
              Select Date:
            </div>
            <Select
              showSearch
              style={{
                width: 155,
                height: 48,
              }}
              placeholder="Please Select"
              options={[
                {
                  value: "1",
                  label: "Last Weeks",
                },
                {
                  value: "2",
                  label: "Last Months",
                },
                {
                  value: "3",
                  label: "Last 2 Months",
                },
                {
                  value: "4",
                  label: "Life Time",
                },
              ]}
            />
          </div>
          <div className="flex-col justify-start items-start gap-2.5 flex">
            <ActivityTimelineValue title="Profile Viewed" value="240" />
            <ActivityTimelineValue title="Interest Sent" value="24" />
            <ActivityTimelineValue title="Photo Request Sent" value="12" />
            <ActivityTimelineValue title="Profiles Shortlisted" value="06" />
            <ActivityTimelineValue
              title="Message Sent"
              value={
                <a className="text-secondary font-semibold" href="#">
                  32
                </a>
              }
            />
            <ActivityTimelineValue
              title="Message Received"
              value={
                <a className="text-secondary font-semibold" href="#">
                  32
                </a>
              }
            />
            <ActivityTimelineValue
              title="Contact Viewed"
              value={
                <a className="text-secondary font-semibold" href="#">
                  32
                </a>
              }
            />
          </div>
        </div>
      </div>
      <div className="w-full justify-start items-start gap-[19px] flex flex-wrap">
        <ActivityTimelineCard heading="Interest">
          <ActivityTimelineValue title="Interest Sent" value="1247" />
          <ActivityTimelineValue title="Interest Received" value="24" />
          <ActivityTimelineValue title="Interested Accepted" value="12" />
          <ActivityTimelineValue title="Interest Denied" value="06" />
          <ActivityTimelineValue title="Interest Pending" value="67" />
        </ActivityTimelineCard>
        <ActivityTimelineCard heading="Photo Request">
          <ActivityTimelineValue title="Photo Request Sent" value="240" />
          <ActivityTimelineValue title="Photo Request Received" value="24" />
          <ActivityTimelineValue title="Photo Request Accepted" value="12" />
          <ActivityTimelineValue title="Photo Request Denied" value="06" />
          <ActivityTimelineValue title="Photo Request Pending" value="65" />
        </ActivityTimelineCard>
        <ActivityTimelineCard heading="Contact Details">
          <ActivityTimelineValue title="Contact Access Remaining" value="27" />
          <ActivityTimelineValue title="Contact Access Remaining" value="24" />
          <ActivityTimelineValue title="Revealed by Other Users" value="5" />
        </ActivityTimelineCard>
        <ActivityTimelineCard heading="Profile View">
          <ActivityTimelineValue title="Profile Viewed" value="1247" />
          <ActivityTimelineValue title="Viewed by Other Users" value="947" />
        </ActivityTimelineCard>
        <ActivityTimelineCard heading="Shortlist">
          <ActivityTimelineValue title="Profiles Shortlisted" value="1247" />
          <ActivityTimelineValue
            title="Shortlisted by Other Users"
            value="947"
          />
        </ActivityTimelineCard>
        <ActivityTimelineCard heading="Messages">
          <ActivityTimelineValue title="Messages Sent" value="1247" />
          <ActivityTimelineValue title="Unread Messages" value="947" />
        </ActivityTimelineCard>
      </div>
      <div className="w-full p-5 justify-end items-end gap-2 flex">
        <div className="w-[68px] h-[36px] flex items-center justify-center rounded-xl bg-[#a6aebb]">
          <img src={images.leftArrowWhite} />
        </div>
        <div className="w-[38px] h-[36px] flex items-center justify-center rounded-xl bg-basePrimary">
          <p className="text-white text-base font-medium font-['Poppins'] leading-normal">
            1
          </p>
        </div>
        <div className="w-[38px] h-[36px] flex items-center justify-center rounded-xl bg-[#a6aebb]">
          <p className="text-white text-base font-medium font-['Poppins'] leading-normal">
            2
          </p>
        </div>
        <div className="w-[38px] h-[36px] flex items-center justify-center rounded-xl bg-[#a6aebb]">
          <p className="text-white text-base font-medium font-['Poppins'] leading-normal">
            ...
          </p>
        </div>
        <div className="w-[38px] h-[36px] flex items-center justify-center rounded-xl bg-[#a6aebb]">
          <p className="text-white text-base font-medium font-['Poppins'] leading-normal">
            7
          </p>
        </div>
        <div className="w-[68px] h-[36px] flex items-center justify-center rounded-xl bg-[#a6aebb]">
          <img className="rotate-180" src={images.leftArrowWhite} />
        </div>
      </div>
    </div>
  );
}
